import { useBaseStyles } from "routes/app/biens/style/styleBase";

export const useStyles = (theme) => ({
  ...useBaseStyles(theme),
});
